<template>
  <div
    class="import-progress-bar"
    v-if="progressStatus"
    style="display: flex; align-items: center;height: 250px;"
  >
    <div style="width: 100%;">
      <div
        style="display: flex;justify-content: center;align-items: center;stroke: #00ab48;fill: #00ab48;color: #00ab48;font-weight: bold;"
      >
        <div class="progress-bar-loader">
          <svg viewBox="0 0 64 64">
            <g stroke-width="0">
              <circle cx="24" cy="0" transform="translate(32,32)" r="6.63154">
                <animate
                  attributeName="r"
                  dur="800ms"
                  values="8;7;6;5;4;3;2;1;8"
                  repeatCount="indefinite"
                />
              </circle>
              <circle
                cx="16.970562748477143"
                cy="16.97056274847714"
                transform="translate(32,32)"
                r="7.63154"
              >
                <animate
                  attributeName="r"
                  dur="800ms"
                  values="1;8;7;6;5;4;3;2;1"
                  repeatCount="indefinite"
                />
              </circle>
              <circle cx="1.4695761589768238e-15" cy="24" transform="translate(32,32)" r="3.57921">
                <animate
                  attributeName="r"
                  dur="800ms"
                  values="2;1;8;7;6;5;4;3;2"
                  repeatCount="indefinite"
                />
              </circle>
              <circle
                cx="-16.97056274847714"
                cy="16.970562748477143"
                transform="translate(32,32)"
                r="3.63154"
              >
                <animate
                  attributeName="r"
                  dur="800ms"
                  values="3;2;1;8;7;6;5;4;3"
                  repeatCount="indefinite"
                />
              </circle>
              <circle
                cx="-24"
                cy="2.9391523179536475e-15"
                transform="translate(32,32)"
                r="3.63154"
              >
                <animate
                  attributeName="r"
                  dur="800ms"
                  values="4;3;2;1;8;7;6;5;4"
                  repeatCount="indefinite"
                />
              </circle>
              <circle
                cx="-16.970562748477143"
                cy="-16.97056274847714"
                transform="translate(32,32)"
                r="3.63154"
              >
                <animate
                  attributeName="r"
                  dur="800ms"
                  values="5;4;3;2;1;8;7;6;5"
                  repeatCount="indefinite"
                />
              </circle>
              <circle
                cx="-4.408728476930472e-15"
                cy="-24"
                transform="translate(32,32)"
                r="4.63154"
              >
                <animate
                  attributeName="r"
                  dur="800ms"
                  values="6;5;4;3;2;1;8;7;6"
                  repeatCount="indefinite"
                />
              </circle>
              <circle
                cx="16.970562748477136"
                cy="-16.970562748477143"
                transform="translate(32,32)"
                r="5.63154"
              >
                <animate
                  attributeName="r"
                  dur="800ms"
                  values="7;6;5;4;3;2;1;8;7"
                  repeatCount="indefinite"
                />
              </circle>
            </g>
          </svg>
        </div>
        <div class="message" v-if="percentage <= 100">Loading {{mode}}..</div>
      </div>

      <div class="bar-container">
        <div class="bar" v-bind:style="{ 'width' : percentage + '%' }"></div>
      </div>
      <div style="padding: 8px 15px;">
        <div style="display: inline;font-size: 13px;color: rgb(134, 134, 134);text-align: center;">
          <div  class="percentage-message" v-if="percentage <= 100">{{percentage}}% completed</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    progressStatus: Boolean,
    percentage: Number,
    mode: String,
  },
  data() {
    return {
    };
  },
  computed: {
    complete() {
      return {
        complete: this.percentage === 100,
      };
    },
  },
  watch: {
    percentage() {
      if (this.percentage === 100) {
        setTimeout(() => {
          this.$emit('updateImportProgressStatus');
        }, 5000);
      }
    },
  },
};
</script>
